// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_cat-coin_cat-coin_module_ts":"68f007f13b6f2b42","src_app_features_cat-profile_cat-profile_module_ts":"75b3775cd9689cfb","src_app_features_me-you-profile_me-you-profile_module_ts":"992422f74a1b283a"}[chunkId] + ".js";
};